import React, { useState } from "react";
import styled from "styled-components";
import OWIGreyscaleIcon from "styles/images/owi-grey.png";
import OWIIconWhite from "styles/images/owi-icon-white.svg";

export default function InbioOWIContentImg({ content }) {
  const UnavailableInbioRewardsLinksAndOWIContent = styled("div")`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(240, 244, 248, 1);
    width: 100%;
    aspect-ratio: 1;
    flex-direction: column;
  `;

  const [imgLoadError, setImgLoadError] = useState(false);

  function onImgLoadError() {
    setImgLoadError(true);
  }

  return (
    <React.Fragment>
      {(content.image && !imgLoadError) ? (
        <div style={{display: "flex"}}>
          <img
            src={content.image}
            onError={onImgLoadError}
            alt="OWI Post"
            style={{ objectFit: "contain", width: "100%" }}
          />
          <img
            src={OWIIconWhite}
            style={{position: "absolute", height: "24px", margin: "2px"}}
          />
        </div>
      ) : (
        <UnavailableInbioRewardsLinksAndOWIContent>
          <img src={OWIGreyscaleIcon}/>
          <span
            style={{fontSize: "10px", color: "grey"}}
          >
            Image Unavailable
          </span>
        </UnavailableInbioRewardsLinksAndOWIContent>
      )}
    </React.Fragment>
  );
}